import { footerNavigation } from "@holocron/shared";
import { SmartLink } from "../common/SmartLink";

export function SiteFooter() {
  return (
    <footer className="site-footer">
      <div className="site-footer-inner">
        <div className="footer-brand">
          <img alt="Holocron Security logo" src="/assets/img/holocron-logo.svg" />
          <p>Conscious Security for AI, infrastructure, evidence, and machine-speed operations.</p>
        </div>

        <div className="footer-column">
          <h2>Quick Links</h2>
          <ul>
            {footerNavigation.quickLinks.map((link) => (
              <li key={link.href}>
                <SmartLink href={link.href}>{link.label}</SmartLink>
              </li>
            ))}
          </ul>
        </div>

        <div className="footer-column footer-contact">
          <h2>Contact</h2>
          <ul>
            {footerNavigation.contact.map((link) => (
              <li key={link.href}>
                <SmartLink href={link.href}>{link.label}</SmartLink>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="site-footer-meta">© 2026 Holocron Security. All rights reserved.</div>
    </footer>
  );
}
